import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, firstValueFrom } from 'rxjs';

export interface PipelineStatuses {
  open: boolean | null;
  lost: boolean | null;
  won: boolean | null;
}

@Injectable()
export class PipelineStatusCheckboxService {
  private readonly statuses$$ = new ReplaySubject<PipelineStatuses>(1);
  readonly statuses$: Observable<PipelineStatuses> = this.statuses$$.asObservable();

  async getValueToInitForm(): Promise<PipelineStatuses> {
    return await firstValueFrom(this.statuses$$);
  }

  storeStatuses(statuses: PipelineStatuses): void {
    this.statuses$$.next(statuses);
  }

  resetFilter(): void {
    this.storeStatuses(null);
  }
}
